import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47f9c0c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "card card-stretch shadow",
  style: {"margin-bottom":"10px"}
}
const _hoisted_2 = {
  class: "card-body",
  style: {"padding":"15px"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Эхлэл")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Лавлагааны тайлан")
const _hoisted_5 = { class: "card shadow" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chart-bar text-dark fs-3" }),
    /*#__PURE__*/_createTextVNode("  "),
    /*#__PURE__*/_createElementVNode("b", null, "Лавлагааны тайлан")
  ])
], -1))
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = ["disabled", "data-kt-indicator"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createTextVNode(" Нийт хандалт  "),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-excel text-success fs-6" })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Түр хүлээнэ үү... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = ["disabled", "data-kt-indicator"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createTextVNode(" Нийт хэрэглэгчээр  "),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-excel text-success fs-6" })
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Түр хүлээнэ үү... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle ms-2"
}
const _hoisted_18 = {
  key: 1,
  class: "fas fa-file-excel text-success fs-4"
}
const _hoisted_19 = {
  style: {"margin-top":"20px"},
  align: "center"
}
const _hoisted_20 = { class: "text-primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_breadcrumb, { "separator-class": "el-icon-arrow-right" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_row, {
          gutter: 10,
          class: "report-filter-row"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 12,
              md: 4
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.yearValue,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.yearValue) = $event)),
                  size: "mini",
                  placeholder: "-- Он сонгох --",
                  style: {"width":"100%"},
                  onChange: _ctx.refreshReport
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 12,
              md: 4
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.monthValue,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.monthValue) = $event)),
                  size: "mini",
                  placeholder: "-- Сар сонгох --",
                  style: {"width":"100%"},
                  onChange: _ctx.refreshReport
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "Бүх сар",
                      value: "*"
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }),
            (_ctx.isu)
              ? (_openBlock(), _createBlock(_component_el_col, {
                  key: 0,
                  xs: 24,
                  sm: 12,
                  md: 4
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.orgTypeValue,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.orgTypeValue) = $event)),
                      size: "mini",
                      placeholder: "-- Төрөл --",
                      style: {"width":"100%"},
                      onChange: _ctx.handleOrgTypeChange
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orgTypes, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.isu)
              ? (_openBlock(), _createBlock(_component_el_col, {
                  key: 1,
                  xs: 24,
                  sm: 12,
                  md: 6
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.selectOrgVal,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectOrgVal) = $event)),
                      size: "mini",
                      filterable: "",
                      clearable: "",
                      placeholder: "-- Байгууллага --",
                      style: {"width":"100%"},
                      onChange: _ctx.refreshReport
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          value: "*",
                          label: "Бүгд"
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredOrgList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 12,
              md: 6
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.searchValue,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchValue) = $event)),
                  size: "mini",
                  clearable: "",
                  placeholder: "Хайх утгаа оруулна уу...",
                  "prefix-icon": "el-icon-search",
                  onClear: _ctx.handleSearchChange,
                  onInput: _ctx.handleSearchChange
                }, null, 8, ["modelValue", "onClear", "onInput"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, {
          gutter: 10,
          class: "report-actions"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 12,
              md: 4
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: _ctx.pageSize,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.pageSize) = $event)),
                  size: "mini",
                  min: 1,
                  max: 100,
                  style: {"width":"100%"},
                  onChange: _ctx.handlePageSizeChange
                }, null, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 12,
              md: 20,
              class: "export-actions"
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  class: "el-button el-button--default el-button--small is-plain",
                  disabled: _ctx.loadingReport !== '',
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getReport('totalAccess'))),
                  "data-kt-indicator": _ctx.loadingReport === 'totalAccess' ? 'on' : 'off'
                }, _hoisted_11, 8, _hoisted_8),
                _createElementVNode("button", {
                  class: "el-button el-button--default el-button--small is-plain",
                  disabled: _ctx.loadingReport !== '',
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getReport('inquiryAllUsers'))),
                  "data-kt-indicator": 
              _ctx.loadingReport === 'inquiryAllUsers' ? 'on' : 'off'
            
                }, _hoisted_15, 8, _hoisted_12)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: _ctx.paginatedTableData,
          border: "",
          size: "small",
          "element-loading-text": "Өгөгдөл татаж байна...",
          "empty-text": "Өгөгдөл байхгүй байна.",
          "cell-style": { textAlign: 'center' },
          "header-cell-style": { textAlign: 'center' },
          style: {"margin-top":"10px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "№",
              width: "55"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_ctx.pageSize * (_ctx.page - 1) + scope.$index + 1), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Хэрэглэгчийн дугаар",
              prop: "username",
              "min-width": "160",
              sortable: ""
            }),
            _createVNode(_component_el_table_column, {
              label: "Байгууллагын код",
              prop: "orgcode",
              "min-width": "140",
              sortable: ""
            }),
            _createVNode(_component_el_table_column, {
              label: "Байгууллага",
              prop: "orgname",
              "min-width": "220",
              sortable: ""
            }),
            _createVNode(_component_el_table_column, {
              label: "Байгууллагын төрөл",
              prop: "orgtype",
              "min-width": "150",
              sortable: ""
            }),
            _createVNode(_component_el_table_column, { label: "Лавлагааны тоо" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "Иргэн",
                  prop: "citizenCount",
                  "min-width": "110",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Гадаад иргэн",
                  prop: "foreignCitizenCount",
                  "min-width": "140",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Хуулийн этгээд",
                  prop: "legalEntityCount",
                  "min-width": "150",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Гадаад хуулийн этгээд",
                  prop: "foreignLegalEntityCount",
                  "min-width": "190",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Холбогдох этгээд иргэн",
                  prop: "relatedCitizenCount",
                  "min-width": "190",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Холбогдох этгээд гадаад иргэн",
                  prop: "relatedForeignCitizenCount",
                  "min-width": "230",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Холбогдох этгээд хуулийн этгээд",
                  prop: "relatedLegalEntityCount",
                  "min-width": "240",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Холбогдох этгээд гадаад хуулийн этгээд",
                  prop: "relatedForeignLegalEntityCount",
                  "min-width": "300",
                  sortable: ""
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Нийт",
              prop: "total",
              "min-width": "100",
              sortable: ""
            }),
            _createVNode(_component_el_table_column, {
              label: "Дэлгэрэнгүй тайлан",
              "min-width": "150"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  class: "customized-link-span",
                  onClick: ($event: any) => (_ctx.getReport('inquiryHistoryByUser', scope.row.username))
                }, [
                  (_ctx.loadingReport === `user:${scope.row.username}`)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17))
                    : (_openBlock(), _createElementBlock("i", _hoisted_18))
                ], 8, _hoisted_16)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _ctx.dataLoading]
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_el_pagination, {
            background: "",
            layout: "prev, pager, next",
            "current-page": _ctx.page,
            "page-size": _ctx.pageSize,
            total: _ctx.filteredTableData.length,
            onCurrentChange: _ctx.handleCurrentChange
          }, null, 8, ["current-page", "page-size", "total", "onCurrentChange"]),
          _createElementVNode("div", _hoisted_20, " Бичлэгийн тоо: " + _toDisplayString(_ctx.filteredTableData.length), 1)
        ])
      ])
    ])
  ], 64))
}